import { FOOTER_ACTIVE_NO } from "../actionTypes/MobileFooterAction"


export const footer_Active_no = (v) => {
    return {
        type:FOOTER_ACTIVE_NO,
        payload:v
    }
}